export default __webpack_public_path__ + "static/media/email-gray.11f02731.svg";